document.addEventListener('algolia.hooks.initialize', function() {
  // Prevent double-registration if the file is loaded twice
  if (window.__ALGOLIA_CUSTOM_HOOKS_INITED__) return;
  window.__ALGOLIA_CUSTOM_HOOKS_INITED__ = true;
 
  console.log('🔍 Algolia custom hooks initializing...');

  // Get customer tags from global window object
  const customerTags = window.customerTags || [];
  const isPractitioner = customerTags.some(tag => tag.toLowerCase().includes('practitioner'));
  const isPatient = customerTags.some(tag => tag.toLowerCase().includes('patient'));

  // get dynamic asset link to bestsellerBadge
  const badgeUrl = window.themeAssets?.bestsellerBadge || '';

  // Function to calculate discounted price based on customer type
  function getDiscountedPrice(price) {
    if (!price) return 0;

    const discounted = isPractitioner ? price * 0.5 : // 50% discount for practitioners
                      isPatient ? price * 0.8 : // 20% discount for patients
                      price; // No discount for others
    const rounded = Math.round(discounted * 100) / 100; // Round to 2 decimal places


    return rounded;
  }

  // Function to format price range
  function formatPriceRange(hit) {
    // If there's no price range, just return the regular price
    if (!hit.price_min || !hit.price_max || hit.price_min === hit.price_max) {
      return `$${getDiscountedPrice(hit.price).toFixed(2)}`;
    }

    // Calculate discounted min and max prices
    const minPrice = getDiscountedPrice(hit.price_min);
    const maxPrice = getDiscountedPrice(hit.price_max);

    return `$${minPrice.toFixed(2)} - $${maxPrice.toFixed(2)}`;
  }

    // Helper: from "url_125x.png 1x, url_250x.png 2x, url_375x.png 3x" get the 3x URL
  function pickHiDpiSrc(srcset, fallbackSrc) {
    if (typeof srcset !== 'string') return fallbackSrc;
    // split on commas, trim, then try to find the one with "3x"
    const candidates = srcset.split(',').map(s => s.trim());
    const threeX = candidates.find(c => /\s3x$/.test(c));
    const target = threeX || candidates[candidates.length - 1] || '';
    const url = target.split(/\s+/)[0]; // take the URL part before the density
    return url || fallbackSrc;
  }

  // === Inject custom pagination widget BEFORE InstantSearch starts ===
  algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', function() {
    // Access the pagination widget from the externals
    const { pagination } = window.algoliaShopify.externals.widgets;

    // Return your custom widget(s) as an array
    return [
      pagination({
        container: '.ais-pagination-container',
        padding: 1, // Number of pages to show on each side of the current page
        showFirst: false,
        showLast: false,
      }),
    ];
  });


  algoliaShopify.hooks.registerHook('afterISStartRemoveDefaultWidget', function(defaultWidgets) {
    // Remove the default pagination widget
    return defaultWidgets.filter(widget => widget.$$widgetType === 'ais.pagination');
  });

  // Hook for search results page
  algoliaShopify.hooks.registerHook(
    'beforeInstantSearchProductTemplate',
    function (_defaultTemplate, hit, html, components, trackSearchAttribution) {
      // Calculate discounted prices for all products
      const price = getDiscountedPrice(hit.price);
      const compareAtPrice = hit.compare_at_price ? getDiscountedPrice(hit.compare_at_price) : null;
      console.log("HIT PRICE", hit.price);
      console.log("PRICE", price);

      // Create a modified hit object with the correct prices
      const modifiedHit = {
        ...hit,
        price: price,
        compare_at_price: compareAtPrice
      };

      const img = algoliaShopify.helpers.renderImage(modifiedHit, 500);
      const hiDpiSrc = pickHiDpiSrc(img.srcset, img.src);
      const isBestSeller = hit.meta?.custom?.best_seller_flag === 1;
      const isSoldOut = hit.inventory_available === false;

      const link = algoliaShopify.helpers.instantsearchLink(modifiedHit);

      return html`
        <div class="card-wrapper product-card-wrapper underline-links-hover">
        <a href="${link}" class="full-unstyled-link" onClick="${() => trackSearchAttribution(modifiedHit)}">
          <div class="card card--standard card--media" style="--ratio-percent: 125.0%;">
            <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 125.0%;">
              <div class="card__media">
                ${isBestSeller && !isSoldOut ? html`
                  <div class="card-badge card-badge--bestseller">
                    <img
                      src="${badgeUrl}"
                      alt="Best Seller"
                      class="badge--bestseller"
                      loading="lazy"
                      width="112"
                      height="24"
                    />
                  </div>
                ` : isSoldOut ? html`
                  <div class="card-badge card-badge--bestseller">
                      <span class="badge badge--bottom-left color-scheme-3" aria-label="Sold out">Sold out</span>
                  </div>
                `: ''}

                <div class="media media--transparent media--hover-effect">
                  <img
                      src="${hiDpiSrc}"
                      sizes="${img.sizes}"
                      alt="${modifiedHit.title}"
                      class="motion-reduce"
                      ${Number(modifiedHit.productPosition) === 1 ? 'fetchpriority="high"' : ''}
                      width="1000"
                      height="1000"
                    />
                </div>
              </div>

              <div class="card__content">
                <div class="card__information">
                  <h3 class="card__heading">
                      ${components.Highlight({ attribute: 'title', hit: modifiedHit })}
                  </h3>
                </div>
                <div class="card__badge bottom left"></div>
              </div>
            </div>

            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading h5">
                    ${components.Highlight({ attribute: 'title', hit: modifiedHit })}
                </h3>

                <div class="card-information">
                  <span class="caption-large light"></span>

                  <div class="price">
                    <div class="price__container">
                      ${
                        compareAtPrice && compareAtPrice > price
                          ? html`
                              <div class="price__sale">
                                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                <span>
                                  <s class="price-item price-item--regular">
                                    ${algoliaShopify.helpers.displayStrikedPrice(price, compareAtPrice)}
                                  </s>
                                </span>
                                <span class="visually-hidden visually-hidden--inline">Sale price</span>
                                <span class="price-item price-item--sale price-item--last">
                                  ${'$' + price.toFixed(2)}
                                </span>
                              </div>
                            `
                          : html`
                              <div class="price__regular">
                                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                <span class="price-item price-item--regular">
                                  $${modifiedHit.price.toFixed(2)}
                                </span>
                              </div>
                            `
                      }

                      <small class="unit-price caption hidden">
                        <span class="visually-hidden">Unit price</span>
                        <span class="price-item price-item--last">
                          <span></span>
                          <span aria-hidden="true">/</span>
                          <span class="visually-hidden">&nbsp;per&nbsp;</span>
                          <span></span>
                        </span>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div><!-- /.card -->
        </a>  
        </div><!-- /.card-wrapper -->
      `;
    }
  );

  // ——— Add "Products" title above the product Stats (matches Articles header style) ———
  // This wraps the default Stats template with a header, keeping the original stats intact.
  // It renders once with the Stats widget and survives InstantSearch re-renders.
  if (!window.__PRODUCTS_TITLE_INJECTED__) {
    window.__PRODUCTS_TITLE_INJECTED__ = true;

    algoliaShopify.hooks.registerHook(
      'beforeInstantSearchStatsTemplate',
      function (_defaultTemplate, data, html) {
        // Render the original stats template first
        const baseStats =
          typeof _defaultTemplate === 'function'
            ? _defaultTemplate(data, html)
            : _defaultTemplate;

        // Prepend our heading using the same structure/classes you used in Articles
        // (h1.ais-h2.ais-h2-custom, living in a header container)
        return html`
          <div class="ais-Stats"> 
              <h1 class="ais-h2 ais-h2-custom">Products</h1>
              ${baseStats}
            </div> 
        `;
      }
    );
  }

  // Hook for autocomplete dropdown
  algoliaShopify.hooks.registerHook(
    'beforeAutocompleteProductTemplate',
    function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
      const { html, item, components } = templateOptions;

      // Calculate discounted prices for all products
      const price = getDiscountedPrice(item.price);
      const compareAtPrice = item.compare_at_price ? getDiscountedPrice(item.compare_at_price) : null;

      // Create a modified item object with the correct prices
      const modifiedItem = {
        ...item,
        price: price,
        compare_at_price: compareAtPrice
      };

      const img = algoliaShopify.helpers.renderImage(modifiedItem, 125);
      const hiDpiSrc = pickHiDpiSrc(img.srcset, img.src); // prefer 3x (e.g., 375x) for crispness
      const isBestSeller = item.meta?.custom?.best_seller_flag === 1;
      const isSoldOut = item.inventory_available === false;

      return html`
        <div class="card-wrapper product-card-wrapper underline-links-hover">
          <a href="${itemLink}" class="full-unstyled-link" onClick="${() => trackSearchAttribution(modifiedItem)}">
            <div class="card card--standard card--media" style="--ratio-percent: 125.0%;">
              <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 125.0%;">
                <div class="card__media">
                  ${isBestSeller && !isSoldOut ? html`
                    <div class="card-badge card-badge--bestseller">
                      <img
                        src="${badgeUrl}"
                        alt="Best Seller"
                        class="badge--bestseller"
                        loading="lazy"
                        width="112"
                        height="24"
                      />
                    </div>
                  ` : isSoldOut ? html`
                    <div class="card-badge card-badge--bestseller">
                       <span class="badge badge--bottom-left color-scheme-3" aria-label="Sold out">Sold out</span>
                    </div>
                  `: ''}

                  <div class="media media--transparent media--hover-effect">
                    <img
                      src="${hiDpiSrc}"
                      sizes="${img.sizes}"
                      alt="${modifiedItem.title}"
                      class="motion-reduce"
                      ${Number(modifiedItem.productPosition) === 1 ? 'fetchpriority="high"' : ''}
                      width="1000"
                      height="1000"
                    />
                  </div>
                </div>

                <div class="card__content">
                  <div class="card__information">
                    <h3 class="card__heading">
                        ${components.Highlight({ attribute: 'title', hit: modifiedItem })}
                    </h3>
                  </div>
                  <div class="card__badge bottom left"></div>
                </div>
              </div>

              <div class="card__content">
                <div class="card__information">
                  <h3 class="card__heading h5">
                      ${components.Highlight({ attribute: 'title', hit: modifiedItem })}
                  </h3>

                  <div class="card-information">
                    <span class="caption-large light"></span>

                    <div class="price">
                      <div class="price__container">
                        ${
                          compareAtPrice && compareAtPrice > price
                            ? html`
                                <div class="price__sale">
                                  <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                  <span>
                                    <s class="price-item price-item--regular">
                                      ${algoliaShopify.helpers.displayStrikedPrice(price, compareAtPrice)}
                                    </s>
                                  </span>
                                  <span class="visually-hidden visually-hidden--inline">Sale price</span>
                                  <span class="price-item price-item--sale price-item--last">
                                    ${'$' + price.toFixed(2)}
                                  </span>
                                </div>
                              `
                            : html`
                                <div class="price__regular">
                                  <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                  <span class="price-item price-item--regular">
                                    ${formatPriceRange(item)}
                                  </span>
                                </div>
                              `
                        }

                        <small class="unit-price caption hidden">
                          <span class="visually-hidden">Unit price</span>
                          <span class="price-item price-item--last">
                            <span></span>
                            <span aria-hidden="true">/</span>
                            <span class="visually-hidden">&nbsp;per&nbsp;</span>
                            <span></span>
                          </span>
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div><!-- /.card -->
          </a>  
        </div><!-- /.card-wrapper -->
      `;
    }
  );

  // Use your actual articles index name
  const ARTICLES_INDEX = 'shopify_articles';
  // expose to any helper that expects window.ARTICLES_INDEX
  window.ARTICLES_INDEX = ARTICLES_INDEX;

  // minimal state for paging and current query
  window.__ARTICLES_STATE__ = window.__ARTICLES_STATE__ || {
    page: 1,            // 1-based
    hitsPerPage: 4,
    lastQuery: '',
    nbHits: 0,
    sort: 'relevance'   // NEW: relevance | title_asc | title_desc
  };

  // Cache for all-articles (per query)
  window.__ARTICLES_CACHE__ = window.__ARTICLES_CACHE__ || {
    query: '',
    hits: [],            // keep for backward-compat (relevance order)
    original: [],        // NEW: relevance order (unaltered)
    processingTimeMS: 0, // NEW: for stats
  };

  // Fetch ALL articles (title-only), then render first 4 via callback.
  // Keeps the same signature so existing calls still work.
  async function fetchArticles(query, callback /* keep options ignored now */) {
    const state = window.__ARTICLES_STATE__;
    const q = (query || '').trim();
    const appId  = window.algoliaShopify.config.app_id;
    const apiKey = window.algoliaShopify.config.search_api_key;
    const indexName = window.ARTICLES_INDEX || `${window.algoliaShopify.config.index_prefix}articles`;
    const client = window.algoliaShopify.externals.algoliasearch(appId, apiKey);
    const index  = client.initIndex(indexName);

    // If query changed, reset page to 1
    if (q !== state.lastQuery) state.page = 1;
    state.lastQuery = q;
    state.hitsPerPage = 4; // fixed: 4 per your requirement

    // If we already have cache for this query, reuse it
    if (window.__ARTICLES_CACHE__.query === q && window.__ARTICLES_CACHE__.hits.length) {
      state.nbHits = window.__ARTICLES_CACHE__.hits.length;
      // render current page slice
      const start = (state.page - 1) * state.hitsPerPage;
      const pageHits = window.__ARTICLES_CACHE__.hits.slice(start, start + state.hitsPerPage);
      callback(pageHits);
      window.__ARTICLES_CLIENT_PAGER_SYNC__ && window.__ARTICLES_CLIENT_PAGER_SYNC__();
      return;
    }

    // New query -> fetch ALL pages
    const HPP = 1000; // Algolia limit (paginationLimitedTo); adjust if your index has a lower setting
    try {
      // 1) first page
      const first = await index.search(q, {
        hitsPerPage: HPP,
      });

      let all = first.hits || [];
      const nbPages = first.nbPages || 1;

      // 2) pull remaining pages if any (careful with large nbPages)
      for (let p = 1; p < nbPages; p++) {
        const res = await index.search(q, {
          hitsPerPage: HPP,
        });
        if (res?.hits?.length) all = all.concat(res.hits);
        // Soft guard: stop if we somehow exceed reported nbHits (rare)
        if (all.length >= (res.nbHits || all.length)) break;
      }

      // Update cache + state
      window.__ARTICLES_CACHE__.query = q;
      window.__ARTICLES_CACHE__.hits  = all;            // keep old name
      window.__ARTICLES_CACHE__.original = all.slice(); // immutable relevance order
      window.__ARTICLES_CACHE__.processingTimeMS =
        (first && first.processingTimeMS) || 0;         // for stats
      state.nbHits = all.length;

      // Render first page (4 hits)
      const start = 0;
      callback(all.slice(start, start + state.hitsPerPage));

      // Build/sync client pager below the list
      window.__ARTICLES_CLIENT_PAGER_SYNC__ && window.__ARTICLES_CLIENT_PAGER_SYNC__();
    } catch (e) {
      console.error('Algolia ALL-articles fetch failed:', e);
      window.__ARTICLES_CACHE__.query = q;
      window.__ARTICLES_CACHE__.hits  = [];
      state.nbHits = 0;
      callback([]);
      window.__ARTICLES_CLIENT_PAGER_SYNC__ && window.__ARTICLES_CLIENT_PAGER_SYNC__();
    }
  }


  algoliaShopify.hooks.registerHook(
  'beforeInstantSearchMainTemplate',
    function (_defaultTemplate, data, html) {
      setTimeout(() => {
        const query =
          data?.state?.query ||
          algoliaShopify?.instantsearch?.search?.helper?.state?.query ||
          '';
        
        // --- keep algolia-articles-section as the last child of .ais-block (no logic changes) ---
        (function ensureArticlesInsideAisBlock() {
          if (window.__ENSURE_ARTICLES_IN_AIS_BLOCK__) return; // avoid double wiring
          window.__ENSURE_ARTICLES_IN_AIS_BLOCK__ = true;

          const moveIfReady = () => {
            const block = document.querySelector('.ais-block');
            const articles = document.getElementById('algolia-articles-section');
            if (!block || !articles) return false;

            // If it's not already the last child of .ais-block, append it there
            if (articles.parentNode !== block || block.lastElementChild !== articles) {
              block.appendChild(articles);
            }
            return true;
          };

          // Try immediately (in case both exist already)
          if (moveIfReady()) return;

          // Otherwise, observe until both appear, then move once and disconnect
          const obs = new MutationObserver(() => {
            if (moveIfReady()) obs.disconnect();
          });
          obs.observe(document.documentElement, { childList: true, subtree: true });
        })();  

       fetchArticles(query, (articles) => {
          renderArticlesList(articles);
          window.__ARTICLES_PAGER_BELOW_SYNC__ && window.__ARTICLES_PAGER_BELOW_SYNC__();
        });

        // Helper: debouncer
        const debounce = (fn, ms = 250) => {
          let t; 
          return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); };
        };

        // ——— helpers for sorting & stats (logic only) ———
        function getActiveHits() {
          const cache = window.__ARTICLES_CACHE__ || {};
          const state = window.__ARTICLES_STATE__ || {};
          const list = cache.original || cache.hits || [];
          if (state.sort === 'title_asc') {
            return list.slice().sort((a, b) => (a.title || '').localeCompare(b.title || '', undefined, { sensitivity: 'base' }));
          }
          if (state.sort === 'title_desc') {
            return list.slice().sort((a, b) => (b.title || '').localeCompare(a.title || '', undefined, { sensitivity: 'base' }));
          }
          return list; // relevance (original order)
        }

        function formatStatsLine() {
          const state  = window.__ARTICLES_STATE__ || {};
          const total  = (window.__ARTICLES_CACHE__?.original?.length) || 0;
          const timeMs = window.__ARTICLES_CACHE__?.processingTimeMS || 0;

          const timeFragment = `in ${(timeMs / 1000).toFixed(3)}s`;

          if (!total) {
            // SIN resultados:
            // - seguimos mostrando el título de la sección
            // - mostramos "No result found in Xs"
            return `
              <div class="ais-Stats">
                <h1 class="ais-h2 ais-h2-custom">Articles, Blogs &amp; Webinars</h1>
                <span class="ais-Stats-text">
                  <span>No result found</span>
                  <span> ${timeFragment}</span>
                </span>
              </div>
            `;
          }

          // CON resultados:
          const start = (state.page - 1) * state.hitsPerPage + 1;
          const end   = Math.min(total, state.page * state.hitsPerPage);

          return `
            <div class="ais-Stats">
              <h1 class="ais-h2 ais-h2-custom">Articles, Blogs &amp; Webinars</h1>
              <span class="ais-Stats-text">
                <span>${start} - ${end} out of <span class="ais-stats--nb-results">${total} results found</span></span>
                <span> ${timeFragment}</span>
              </span>
            </div>
          `;
        }

        // Render helper so we don’t repeat the markup
        // === ONLY replace this function ===
        function renderArticlesList(articles) {
          const container = document.getElementById('algolia-articles-section');
          if (!container) return;

          // (all your helpers stay above; we reuse them here)
          // build cards with your exact structure
          const stripHtml = (html = '') => {
            const tmp = document.createElement('div');
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || '';
          };
          const truncate = (s = '', n = 280) => (s.length > n ? s.slice(0, n - 1) + '…' : s);
          const getArticleUrl = (a) => {
            if (a?.url) return a.url;
            const blogHandle = a?.blog?.handle || a?.blog_handle;
            const handle = a?.handle || '';
            if (blogHandle && handle) return `/blogs/${blogHandle}/${handle}`;
            if (handle) return `/blogs/${handle}`;
            return '#';
          };
          const splitTags = (tagsArr = []) => {
            const withType = [], withoutType = [];
            (tagsArr || []).forEach(t => {
              if (typeof t !== 'string') return;
              if (t.indexOf('Content Type:') === 0) withType.push(t);
              else if (t.trim()) withoutType.push(t);
            });
            return { withType, withoutType };
          };
          const computeCtaAndIcon = (tags = []) => {
            let button_text = 'Read Article';
            let iconUrl = window.themeAssets?.guidesIcon || null;
            const has = (substr) => tags.some(t => typeof t === 'string' && t.includes(substr));
            if (has('Therapeutic Diet Guides')) { button_text = 'Read Diet Guide'; iconUrl = window.themeAssets?.guidesIcon || null; }
            else if (has('Clinical Protocol'))   { button_text = 'Read Protocol';   iconUrl = window.themeAssets?.protocolsIcon || null; }
            else if (has('Webinar'))             { button_text = 'Watch Webinar';   iconUrl = window.themeAssets?.webinarIcon || null; }
            return { button_text, iconUrl };
          };
          const buildCard = (a) => {
            const allTags = a?.tags || a?._tags || [];
            const { withType, withoutType } = splitTags(allTags);
            const contentTypeTag = (withType[0] || '').replace('Content Type:', '').trim();
            const rawTitle = (a?.title || '').trim();
            const titleTrunc = rawTitle.length > 55 ? (rawTitle.slice(0, 54) + '…') : rawTitle;
            const url = getArticleUrl(a);
            const descRaw = a?.excerpt || a?.excerpt_html || a?.body_html_safe || stripHtml(a?.body_html || '') || '';
            const desc = truncate(descRaw, 280);
            const { button_text, iconUrl } = computeCtaAndIcon(allTags);
            const imageHtml = iconUrl
              ? `<img src="${iconUrl}" class="motion-reduce" width="83" height="73" alt="">`
              : `<div style="height:73px;display:block"></div>`;
            const chipsHtml = withoutType.length
              ? withoutType.map(t => `<span class="chip">${t}</span>`).join('')
              : `<div style="height:31px;display:block"></div>`;
            const labelHtml = contentTypeTag
              ? `<span>${contentTypeTag}</span>`
              : `<div style="height:28.8px;display:block"></div>`;

            // keep EXACT card structure
            return `
              <div class="card">
                <div class="card-image">${imageHtml}</div>
                <div class="card-content">
                  <div class="card-label">${labelHtml}</div>
                  <div class="card-title">${titleTrunc.replace(/</g, '&lt;')}</div>
                  <div class="card-tags">${chipsHtml}</div>
                  <p class="card-description">${desc}</p>
                  <a href="${url}" class="card-button">${button_text}</a>
                </div>
              </div>
            `;
          };

          const headerStats = formatStatsLine();
          const state = window.__ARTICLES_STATE__ || {};
          const currentSort = state.sort || 'relevance';

          // Header (Stats + Sort) + your card grid
          if (articles && articles.length) {
            container.innerHTML = `
              <div class="ais-search-header">
                <div class="ais-stats-container">
                  ${headerStats}
                </div>
                <div class="ais-sort">
                  Sorted by 
                  <span class="ais-sort-orders-container">
                    <div class="ais-SortBy">
                      <select class="ais-SortBy-select" aria-label="Sort results by">
                        <option class="ais-SortBy-option" value="relevance"   ${currentSort==='relevance'  ? 'selected' : ''}>Relevance</option>
                        <option class="ais-SortBy-option" value="title_asc"   ${currentSort==='title_asc' ? 'selected' : ''}>Name A–Z</option>
                        <option class="ais-SortBy-option" value="title_desc"  ${currentSort==='title_desc'? 'selected' : ''}>Name Z–A</option>
                      </select>
                    </div>
                  </span>
                </div>
              </div>

              <div id="ais-Search-card" class="card-section">
                ${articles.map(buildCard).join('')}
              </div>
            `;
          } else {
            // sin resultados de artículos para esta query
            container.innerHTML = `
              <div class="ais-search-header">
                <div class="ais-stats-container">
                  ${headerStats}
                </div>

                <div class="ais-sort">
                  Sorted by 
                  <span class="ais-sort-orders-container">
                    <div class="ais-SortBy">
                      <select class="ais-SortBy-select" aria-label="Sort results by">
                        <option class="ais-SortBy-option" value="relevance"   ${currentSort==='relevance'  ? 'selected' : ''}>Relevance</option>
                        <option class="ais-SortBy-option" value="title_asc"   ${currentSort==='title_asc' ? 'selected' : ''}>Name A–Z</option>
                        <option class="ais-SortBy-option" value="title_desc"  ${currentSort==='title_desc'? 'selected' : ''}>Name Z–A</option>
                      </select>
                    </div>
                  </span>
                </div>
              </div>

              <div class="ais-hits-container ais-results-as-block">
                <div class="ais-Hits ais-Hits--empty">
                  <div class="ais-hit-empty">
                    <div class="ais-hit-empty--title">No result found</div>
                    <div class="ais-hit-empty--clears">
                      Try
                      <a class="ais-hit-empty--clear-filters ais-link">clearing the filters</a>
                      or
                      <a class="ais-hit-empty--clear-input ais-link">changing your input</a>
                    </div>
                  </div>
                </div>
              </div>

              <div id="ais-Search-card" class="card-section"></div>
            `;
          }

          // Bind sort change (re-renders page 1 of the active order)
          const sortEl = container.querySelector('.ais-SortBy-select');
          if (sortEl) {
            sortEl.addEventListener('change', () => {
              const val = sortEl.value;
              window.__ARTICLES_STATE__.sort = (val === 'title_asc' || val === 'title_desc') ? val : 'relevance';
              // reset to first page on sort (common UX)
              window.__ARTICLES_STATE__.page = 1;
              // slice from active list and paint
              const active = getActiveHits();
              const slice = active.slice(0, window.__ARTICLES_STATE__.hitsPerPage);
              window.renderArticlesList(slice);
            });
          }

          // keep the client pager synced under the list
          window.__ARTICLES_CLIENT_PAGER_SYNC__ && window.__ARTICLES_CLIENT_PAGER_SYNC__();
        }

        // (make sure this line exists once so pager can call it)
        window.renderArticlesList = renderArticlesList;

        // --------- Client-side Pager (uses cache + state, no network) ---------
        (function mountClientArticlesPager() {
          if (window.__ARTICLES_CLIENT_PAGER_MOUNTED__) return;
          window.__ARTICLES_CLIENT_PAGER_MOUNTED__ = true;

          function ensurePagerContainer() {
            const section = document.getElementById('algolia-articles-section');
            if (!section) return null;
            // we render below whatever `renderArticlesList` drew
            const block = section.querySelector('.card-section') || section.querySelector('.ais-articles-block');
            if (!block) return null;

            let pager = document.getElementById('algolia-articles-pagination-below');
            if (!pager) {
              pager = document.createElement('div');
              pager.id = 'algolia-articles-pagination-below';
              pager.className = 'ais-Pagination';
              block.insertAdjacentElement('afterend', pager);
            } else if (pager.previousElementSibling !== block) {
              block.insertAdjacentElement('afterend', pager);
            }
            return pager;
          }

          function renderPager() {
            const dest = ensurePagerContainer();
            if (!dest) return;

            const state = window.__ARTICLES_STATE__ || { page: 1, hitsPerPage: 4 };
            const active = getActiveHits();                         // NEW: use sorted list
            const totalHits = Math.max(0, active.length);           // CHANGED
            const nbPages = Math.max(1, Math.ceil(totalHits / state.hitsPerPage)); // CHANGED
            const cur0 = Math.min(Math.max(0, state.page - 1), nbPages - 1); // 0-based current

            // ---- window of 4 pages ----
            const maxBtns = 3;
            let start = Math.max(0, cur0 - Math.floor(maxBtns / 2));
            let end = start + maxBtns - 1;
            if (end > nbPages - 1) {
              end = nbPages - 1;
              start = Math.max(0, end - (maxBtns - 1));
            }

            const pages = [];
            for (let p = start; p <= end; p++) pages.push(p);

            const hidePrev = cur0 === 0;
            const hideNext = cur0 >= nbPages - 1;

            dest.innerHTML = `
              <ul class="ais-Pagination-list">
                <!-- step previous -->
                <li class="ais-Pagination-item" style="${hidePrev ? 'display:none;' : ''}">
                  <a class="ais-Pagination-link" data-page="${cur0 - 1}" aria-label="Previous">‹</a>
                </li>

                ${pages.map(p => `
                  <li class="ais-Pagination-item">
                    <a class="ais-Pagination-link ${p === cur0 ? 'ais-Pagination-link--selected' : ''}"
                      data-page="${p}" aria-current="${p === cur0 ? 'page' : 'false'}">${p + 1}</a>
                  </li>
                `).join('')}

                <!-- step next -->
                <li class="ais-Pagination-item" style="${hideNext ? 'display:none;' : ''}">
                  <a class="ais-Pagination-link" data-page="${cur0 + 1}" aria-label="Next">›</a>
                </li>
              </ul>
            `;

            // --- adjust margin when no results ---
            (function () {
              // Step 1: grab ALL <li class="ais-Pagination-item"> inside the paginator we just rendered in `dest`
              const allItemsNodeList = dest.querySelectorAll('.ais-Pagination-list .ais-Pagination-item');
              if (!allItemsNodeList.length) {
                return; // no items found, stop here
              }

              // Convert NodeList into an array so we can use reverse() and find()
              const allItems = Array.from(allItemsNodeList);

              // Step 2: get the last VISIBLE item (not display:none)
              const lastVisibleItem = allItems
                .slice() // copy
                .reverse()
                .find(el => window.getComputedStyle(el).display !== 'none');

              // If there’s no visible item, stop here
              if (!lastVisibleItem) {
                return;
              }

              // Step 3: go up to the DIRECT parent of the pagination list
              // Expected structure:
              // <div class="ais-Pagination ...maybe ais-Pagination--noRefinement?...">
              //    <ul class="ais-Pagination-list">
              //      <li class="ais-Pagination-item">...</li>
              //      ...
              //    </ul>
              // </div>
              //
              // lastVisibleItem.parentElement is <ul class="ais-Pagination-list">
              // go one level up: parentElement.parentElement -> <div class="ais-Pagination ...">
              const paginationListEl   = lastVisibleItem.parentElement; // <ul class="ais-Pagination-list">
              const paginationWrapper  = paginationListEl ? paginationListEl.parentElement : null; // <div class="ais-Pagination ...">

              if (!paginationWrapper || !paginationWrapper.classList) {
                return; // no valid wrapper, abort safely
              }

              // Step 4: inspect parent’s classes (your approach)
              const parentClasses = Array.from(paginationWrapper.classList); // ['ais-Pagination','ais-Pagination--noRefinement',...]
              const hasNoRefinementClass = parentClasses.includes('ais-Pagination--noRefinement');

              // Step 5: if the paginator belongs to a wrapper with "ais-Pagination--noRefinement"
              // (e.g. product pagination or Algolia’s empty paginator), DO NOT modify anything.
              if (hasNoRefinementClass) {
                // before exiting, clean any marginRight previously added
                allItems.forEach(el => {
                  el.style.marginRight = '';
                });
                return;
              }

              // Step 6: final behavior based on totalHits:
              // - totalHits === 0  -> add margin-right:42px to the last visible item
              // - totalHits > 0    -> clear any custom margins
              if (totalHits === 0) {
                // First clean all margins, in case we’re coming from a previous state
                allItems.forEach(el => {
                  el.style.marginRight = '';
                });

                lastVisibleItem.style.marginRight = '42px';
              } else {
                // If there are results again, remove all margins
                allItems.forEach(el => {
                  el.style.marginRight = '';
                });
              }
            })();

            // Wire clicks (no network): slice from cache and re-render list
            dest.querySelectorAll('.ais-Pagination-link').forEach(a => {
              a.addEventListener('click', (e) => {
                e.preventDefault();
                const p0 = Number(a.getAttribute('data-page'));
                if (!Number.isFinite(p0)) return;
                renderPage(p0 + 1); // renderPage expects 1-based
              });
            });
          }

          function renderPage(page1) {
            const state = window.__ARTICLES_STATE__;
            const cache = window.__ARTICLES_CACHE__;
            if (!cache?.hits) return;

            // Clamp page
            const active = getActiveHits();                         // NEW: use sorted list
            const nbPages = Math.max(1, Math.ceil(active.length / state.hitsPerPage)); // CHANGED
            state.page = Math.min(Math.max(1, page1), nbPages);

            // Slice and render
            const start = (state.page - 1) * state.hitsPerPage;
            const pageHits = active.slice(start, start + state.hitsPerPage);          // CHANGED
            if (typeof window.renderArticlesList === 'function') {
              window.renderArticlesList(pageHits);
            } else {
              // very rare: fallback
              const container = document.getElementById('algolia-articles-section');
              if (container) {
                container.innerHTML = pageHits.length ? `
                  <div id="ais-Search-card" class="card-section">
                    ${pageHits.map(h => `
                      <div class="card"><div class="card-content"><div class="card-title">${(h.title || '').replace(/</g, '&lt;')}</div></div></div>
                    `).join('')}
                  </div>` : '';
              }
            }

            // Rebuild pager to reflect new current page
            renderPager();
          }

          // expose sync so your existing code can trigger rebuild after any render
          window.__ARTICLES_CLIENT_PAGER_SYNC__ = renderPager;

          // small init try (in case list is already painted)
          setTimeout(renderPager, 0);
        })();

        // Wire the search box (typed queries) to refresh articles
        (function wireArticlesToSearchBox() {
          if (window.__WIRED_ARTICLES_TO_SEARCHBOX__) return;
          window.__WIRED_ARTICLES_TO_SEARCHBOX__ = true;

          const attach = (inputEl) => {
            if (!inputEl || inputEl.__ARTICLES_WIRED__) return;
            inputEl.__ARTICLES_WIRED__ = true;

            const updateFromValue = debounce(() => {
              const q = inputEl.value || '';
              fetchArticles(q, renderArticlesList);
            }, 250);

            // On typing
            inputEl.addEventListener('input', updateFromValue);

            // On hitting Enter / form submit
            const form = inputEl.closest('form');
            if (form) {
              form.addEventListener('submit', (e) => {
                // allow the normal submit/instantsearch behavior, just also refresh articles
                const q = inputEl.value || '';
                fetchArticles(q, renderArticlesList);
              });
            }
          };

          // Try now if it already exists
          const now = document.querySelector('.ais-SearchBox-input');
          if (now) attach(now);

          // Otherwise observe until it appears
          const obs = new MutationObserver((mutations) => {
            for (const m of mutations) {
              for (const node of m.addedNodes) {
                if (
                  node.nodeType === 1 &&
                  (node.matches?.('.ais-SearchBox-input') ||
                  node.querySelector?.('.ais-SearchBox-input'))
                ) {
                  attach(node.matches('.ais-SearchBox-input') ? node : node.querySelector('.ais-SearchBox-input'));
                  obs.disconnect();
                  return;
                }
              }
            }
          });
          obs.observe(document.documentElement, { childList: true, subtree: true });
        })();

        // --- pagination after Hits, without querying for `.ais-Hits` ---
        const placePaginationAfterHits = () => {
          const paginationSection = document.querySelector('.ais-pagination-container');
          const hitsContainer = document.querySelector('.ais-page .ais-hits-container.ais-results-as-block');
          if (!paginationSection || !hitsContainer) return;

          // If hits are rendered later, observe the container and react when the Hits node arrives.
          const observer = new MutationObserver((mutations, obs) => {
            for (const m of mutations) {
              for (const node of m.addedNodes) {
                // We don't query for `.ais-Hits`; we just check the node that arrived.
                if (node.nodeType === 1 && node.classList && node.classList.contains('ais-Hits')) {
                  node.insertAdjacentElement('afterend', paginationSection);
                  obs.disconnect();
                  return;
                }
              }
            }
          });

          // Start watching for Hits to be added (it’s created by InstantSearch render)
          observer.observe(hitsContainer, { childList: true, subtree: false });
        };

        // Run once now (sets up the observer). You can re-run on any render event too.
        placePaginationAfterHits();

        // === Decorate InstantSearch <li class="ais-Hits-item"> to match Dawn grid (resilient) ===
        (function hookHitsGridDecoration() {
          // Apply Dawn grid classes + animation props to <ol> and its <li>s
          function applyGridDecorations(listEl) {
            if (!listEl) return;

            // Add Dawn grid classes to the hits list container itself
            listEl.classList.add(
              'grid',
              'product-grid',
              'grid--1-col-tablet-down',
              'grid--3-col-desktop'
            );

            // Decorate each <li class="ais-Hits-item">
            const items = listEl.querySelectorAll(':scope > .ais-Hits-item');
            items.forEach((li, idx) => {
              if (li.__decorated__) return;
              li.__decorated__ = true;

              li.classList.add(
                'grid__item',
                'scroll-trigger',
                'animate--slide-in'
              );
              li.setAttribute('data-cascade', '');

              // read Algolia position if available for animation ordering
              const posAttr = li
                .querySelector('[data-algolia-position]')
                ?.getAttribute('data-algolia-position');

              const order = Number(posAttr) || (idx + 1);
              li.style.setProperty('--animation-order', String(order));
            });
          }

          // Observe mutations on a specific <ol> so when hits change we re-decorate
          function observeHitsList(listEl) {
            if (!listEl) return;
            // avoid attaching multiple observers to the same node
            if (listEl.__hitsObserverAttached__) return;
            listEl.__hitsObserverAttached__ = true;

            // initial decorate
            applyGridDecorations(listEl);

            const mo = new MutationObserver(() => {
              requestAnimationFrame(() => applyGridDecorations(listEl));
            });
            mo.observe(listEl, { childList: true });

            // remember which list we are currently watching
            window.__HITS_LIST_OBSERVED__ = listEl;
          }

          // Find current hits <ol>
          function findHitsList() {
            return document.querySelector('.ais-Hits .ais-Hits-list');
          }

          // Try right now
          const initialList = findHitsList();
          if (initialList) {
            observeHitsList(initialList);
          }

          // Global observer to catch when a NEW .ais-Hits-list appears
          // (covers: first load had 0 results so no list, then later results appear;
          // covers: InstantSearch swaps out the entire list node)
          const globalMo = new MutationObserver(() => {
            requestAnimationFrame(() => {
              const current = findHitsList();
              if (!current) return;

              if (window.__HITS_LIST_OBSERVED__ !== current) {
                observeHitsList(current);
              } else {
                // even if it's same node, re-apply in case classes were nuked
                applyGridDecorations(current);
              }
            });
          });
          globalMo.observe(document.documentElement, { childList: true, subtree: true });

          // Also hook into Algolia's render event each time it rerenders
          document.addEventListener('algolia.hooks.render', () => {
            requestAnimationFrame(() => {
              const current = findHitsList();
              if (!current) return;

              if (window.__HITS_LIST_OBSERVED__ !== current) {
                observeHitsList(current);
              } else {
                applyGridDecorations(current);
              }
            });
          });
        })();

        // If your theme emits this event on each render, keep it resilient:
        document.addEventListener('algolia.hooks.render', placePaginationAfterHits, { once: false });

        // === Hide disabled pagination items (Products + Articles) ===
        // (function hideDisabledPaginationItems() {
        //   function hideDisabled() {
        //     document.querySelectorAll('.ais-Pagination-item--disabled').forEach(el => {
        //       el.style.display = 'none';
        //     });
        //   }

        //   // Run immediately after load
        //   hideDisabled();

        //   // Run after every Algolia render (products + articles)
        //   document.addEventListener('algolia.hooks.render', () => {
        //     requestAnimationFrame(hideDisabled);
        //   });

        //   // Also observe the Articles section (since it's re-rendered via JS)
        //   const articlesSection = document.getElementById('algolia-articles-section');
        //   if (articlesSection) {
        //     const mo = new MutationObserver(() => requestAnimationFrame(hideDisabled));
        //     mo.observe(articlesSection, { childList: true, subtree: true });
        //   }
        // })();
      }, 0);

      const baseTemplate =
        typeof _defaultTemplate === 'function'
          ? _defaultTemplate(data, html)
          : _defaultTemplate;

      return html`${baseTemplate}<div id="algolia-articles-section"></div>`;
    }
  );

  // --- Simple watcher to rename "Selected filters" facet header ---
  (function renameSelectedFiltersHeader() {
    if (window.__RENAMED_SELECTED_HEADER__) return;
    window.__RENAMED_SELECTED_HEADER__ = true;

    // The exact class Shopify themes usually give the header:
    const selector =
      '.ais-current-refined-values--header.ais-facet--header.ais-header, .ais-CurrentRefinements .ais-facet--header, .ais-CurrentRefinements-header';

    function updateHeader() {
      const headers = document.querySelectorAll(selector);
      headers.forEach((el) => {
        const current = (el.textContent || '').trim();
        if (/^Selected filters$/i.test(current)) {
          el.textContent = 'Selected';
        }
      });
    }

    // Run once right away
    updateHeader();

    // Run after each Algolia render (theme usually dispatches this)
    document.addEventListener('algolia.hooks.render', () => {
      requestAnimationFrame(updateHeader);
    });

    // As a safety net, watch DOM mutations in the facets area
    const facetsRoot =
      document.querySelector('.ais-facets, .ais-left-column, .ais-Panelset, .ais-refinements') || document.body;
    const mo = new MutationObserver(() => {
      requestAnimationFrame(updateHeader);
    });
    mo.observe(facetsRoot, { childList: true, subtree: true });
  })();
});